import { ChangeDetectionStrategy, Component, OnInit, computed, inject, model, output } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

import { Observable } from 'rxjs';

import { FragmentService } from '@fcom/common/services/fragments/fragment.service';
import { MediaQueryService } from '@fcom/common/services/media-query/media-query.service';
import { CmsArticle } from '@fcom/core-api/interfaces/cms-interface';
import { ModalButtons } from '@fcom/ui-components/components/modal/interfaces';
import { AspectRatioString } from '@fcom/common/interfaces/images.interface';

@Component({
  selector: 'fin-sustainablity-info-modal',
  templateUrl: './sustainablity-info-modal.component.html',
  styleUrls: ['./sustainablity-info-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SustainablityInfoModalComponent implements OnInit {
  private fragmentService = inject(FragmentService);
  private mediaQueryService = inject(MediaQueryService);

  modalOpen = model<boolean>();

  closeModal = output<void>();

  safArticle$: Observable<CmsArticle>;

  public readonly ModalButtons = ModalButtons;
  private readonly isMobile = this.mediaQueryService.isBreakpoint('mobile');
  readonly aspectRatio = computed((): AspectRatioString => {
    return this.isMobile() ? '4x3' : '21x9';
  });
  readonly aspectRatio$ = toObservable(this.aspectRatio);

  ngOnInit(): void {
    this.safArticle$ = this.fragmentService.getFragment<CmsArticle>('fragments.safInfo.url');
  }
}
